<template>
  <div class="auction-grid">

    <template >
      <AuctionCard
        v-for="auction in auctions"
        :key="auction.id"
        :auction="auction"
        @bid="onPlaceBid"
      />
    </template>
  </div>
</template>

<script>
import AuctionCard from './AuctionCard.vue'

export default {
  name: 'AuctionGrid',
  components: {
    AuctionCard
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    auctions() {
      return this.$store.getters['auction/activeAuctions']
    },
    hasAuctions() {
      return this.$store.getters['auction/hasAuctions']
    },
    auction() {
      return this.$store.getters['auction/auction']
    }
  },
  methods: {
    onPlaceBid(bidData) {
      this.$emit('bid', bidData)
    }
  },
}
</script>

